// removed by extract-text-webpack-plugin
module.exports = {"root":"Landing-root","rootPositioned":"Landing-rootPositioned","productName":"Landing-productName","productLogo":"Landing-productLogo","loadsSheet":"Landing-loadsSheet","loadsHeader":"Landing-loadsHeader","slogan":"Landing-slogan","loadsFormWrap":"Landing-loadsFormWrap","loadsForm":"Landing-loadsForm","heapBadge":"Landing-heapBadge","heapBadgeImage":"Landing-heapBadgeImage"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Landing/index.css
// module id = 1711
// module chunks = 0